import gql from 'graphql-tag'

export default gql`
  fragment PostComments on Post {
    comments {
      author {
        id
        image
        name
        type
        fkey
        userRef
      }
      isHidden
      content
      id
      insertedAt
      updatedAt
      replyToCommentId
    }
  }
`
